// import CompanyDetails from "@/Components/Settings/CompanyDetails";
// import CompanySettings from "@/Components/Settings/CompanySettings";
import LockManager from "@/Components/Settings/LockManager";
// import Reporting from "@/Components/Settings/Reporting";
import UserLogin from "@/Components/Settings/UserLogin";
import { Card } from "@/Components/ui/card";
import { Tabs, TabsContent, TabsList, TabsTrigger } from "@/Components/ui/tabs";
import { /*Building2,*/ LockKeyholeOpen, /*CalendarCog, SlidersHorizontal,*/ UserCog, Users } from "lucide-react";
import ManageUsers from "@/Components/Settings/ManageUsers";
import React, { useState } from "react";
import { useLocation } from "react-router-dom";
import { AppContext } from "@/App";
import UserPreferences from "@/Components/Settings/UserPreferences";
import { useResponsiveZoom } from "@/hooks/use-responsive-zoom";
import { useIsMobile } from "@/hooks/use-mobile";

function Settings() {
  const appContext = React.useContext(AppContext);
  const isMobile = useIsMobile();
  const zoomLevel = useResponsiveZoom();
  const defaultTab = "userLogin"; //appContext.applicationUser?.role === "Admin" ? "company" : "userLogin";
  const [tab, setTab] = useState(defaultTab);
  const onTabChange = (value: string) => {
    setTab(value);
  };

  const { state } = useLocation();

  const tabs = [
    //"company",
    //"companySettings",
    "userLogin",
    "userPreferences",
    "users",
    "lockManager",
    // "reporting",
  ];

  React.useEffect(() => {
    setTab(state?.tab || defaultTab);
    const down = (e: KeyboardEvent) => {
      if (e.key === "PageUp" && (e.shiftKey)) {
        e.preventDefault()
        handleNavigateTabs(-1);
      }
      else if (e.key === "PageDown" && (e.shiftKey)) {
        e.preventDefault()
        handleNavigateTabs(1);
      }
    }
    document.addEventListener("keydown", down)
    return () => document.removeEventListener("keydown", down)
  }, []);

  const handleNavigateTabs = (val: number) => {
    setTab((prevTab) => {
      let index = tabs.indexOf(prevTab);
      index += val;
      if (index < 0) {
        index = tabs.length - 1;
      } else if (index >= tabs.length) {
        index = 0;
      }
      return tabs[index];
    });
  }

  return (
    <Card className={`${isMobile ? "mb-8" : "m-2 p-2"} flex flex-col items-center`} style={{ zoom: zoomLevel }}>
      {!isMobile && <h1 className="text-3xl">Settings</h1>}
      <Tabs value={tab} onValueChange={onTabChange} defaultValue={defaultTab} className="w-full p-2">
        <TabsList className={`${isMobile ? 'w-full h-12 text-2xl mb-4' : ''}`}>
          <TabsTrigger value="userLogin"><UserCog className={`${isMobile ? "h-7 w-7" : ""}`} /><span className={`${isMobile ? "text-xl px-2" : "px-2"}`}>User Login</span></TabsTrigger>
          <TabsTrigger value="userPreferences"><UserCog className={`${isMobile ? "h-7 w-7" : ""}`} /><span  className={`${isMobile ? "text-xl px-2" : "px-2"}`}>User Preferences</span></TabsTrigger>
          {appContext.applicationUser?.role === "Admin" && (
            <>
              {/* <TabsTrigger value="company" className=""><Building2 /><span className="px-2">Company Details</span></TabsTrigger>
              <TabsTrigger value="companySettings"><SlidersHorizontal /><span className="px-2">Company Settings</span></TabsTrigger> */}
              <TabsTrigger value="users"><Users className={`${isMobile ? "h-7 w-7" : ""}`} /><span  className={`${isMobile ? "text-xl px-2" : "px-2"}`}>Users</span></TabsTrigger>
              <TabsTrigger value="lockManager"><LockKeyholeOpen className={`${isMobile ? "h-7 w-7" : ""}`} /><span className={`${isMobile ? "text-xl px-2" : "px-2"}`}>Lock Manager</span></TabsTrigger>
              {/* <TabsTrigger value="reporting"><CalendarCog /><span className="px-2">Reporting</span></TabsTrigger> */}
            </>
          )}
        </TabsList>
        {appContext.applicationUser?.role === "Admin" && (
          <>
            {/* <TabsContent value="company"><CompanyDetails /></TabsContent>
            <TabsContent value="companySettings"><CompanySettings /></TabsContent> */}
            <TabsContent value="users"><ManageUsers /></TabsContent>
            <TabsContent value="lockManager"><LockManager /></TabsContent>
              
            {/* <TabsContent value="reporting"><Reporting /></TabsContent> */}
          </>
        )}
        <TabsContent value="userPreferences"><UserPreferences /></TabsContent>
        <TabsContent value="userLogin"><UserLogin /></TabsContent>
      </Tabs>
    </Card>
  );
}

export default Settings;